import React, { Component } from "react";
import { compose, withState, withActions } from "containers/HOC";
import { withRouter } from "react-router-dom";
import Details from "./Details";
import { submitFertiliser as editFertiliser, deleteFertiliser } from "./_actions";
import * as utils from "common/utils";
import { modalInlineClose, modalInlineOpen, confirm } from "containers/App/_actions";
import { getCompositions } from "../../Custom/_actions";

class FertiliserEdit extends Component {
    componentDidMount() {
        this.props.getCompositions();
    }
    deleteFertiliserPrompt() {
        this.props.confirm(`Are you sure you want to delete this fertiliser`, () => this.deleteFertiliser());
    }
    deleteFertiliser() {
        this.props.deleteFertiliser(this.props.farmId, this.props.budget.id, this.props.fertiliser, true);
    }
    render() {
        if (!this.props.fertiliser) return null;
        const { farm, fertiliserBudget } = this.props;
        return <Details farm={farm} budget={fertiliserBudget} fertiliser={this.props.fertiliser} submit={this.props.editFertiliser} refData={this.props.refData} location={this.props.location} isNew={false} history={this.props.history} deleteFertiliserPrompt={() => this.deleteFertiliserPrompt()} deleteFertiliser={(farmId, budgetId, fertiliser) => this.props.deleteFertiliser(farmId, budgetId, fertiliser, true)} modalInlineClose={this.props.modalInlineClose} modalInlineOpen={this.props.modalInlineOpen} customCompositions={this.props.customCompositions} />;
    }
}

export default compose(
    withRouter,
    withState((state, ownProps) => {
        const fertiliserId = ownProps.match.params.fertiliserId;
        const budget = utils.clone(ownProps.budget);
        const fertiliser = budget ? budget.fertiliser.find((i) => i.id === fertiliserId) : null;
        return {
            ...ownProps,
            refData: state.app.refData,
            fertiliser: fertiliser,
            fertiliserBudget: budget,
            fertiliserId: fertiliserId,
            customCompositions: state.customNutrients.nutrientCompositions,
        };
    }),
    withActions({ editFertiliser, modalInlineClose, modalInlineOpen, deleteFertiliser, confirm, getCompositions })
)(FertiliserEdit);
